// extracted by mini-css-extract-plugin
module.exports = {"rating":"ij-z","numberOfStars":"jj-z","count":"kj-z"};